import React, { Component } from 'react'
import { routerActions } from 'connected-react-router'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Header, Form, Message, Table } from 'semantic-ui-react'

import * as PaymentLinks from '../../store/PaymentLinks'

class CreatePaymentLink extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: null,
            name: '',
            value: '',
            product: '',
            metadata: {},
        }

        this.onChange = this.onChange.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
    }

    onChange(e, { name, value }) {
        this.setState({ [name]: value })
    }

    async onSubmit(e) {
        const { actions } = this.props
        try {
            if (!this.state.product) {
                throw new Error('Product is required')
            }
            const product = this.props.products.find((p) => p.id === this.state.product)
            const paymentLink = {
                lineItems: [{ price: { id: product.defaultPrice.id }, quantity: 1 }],
                metadata: this.state.metadata,
            }
            await actions.createPaymentLink(paymentLink)
            actions.replace('/admin')
            this.setState({ error: null, name: '', value: '', product: '', metadata: {} })
        } catch (error) {
            this.setState({ error: error.message })
        }
    }

    render() {
        const { error } = this.state
        console.log('CreatePaymentLink', this.props)

        return (
            <div className="paymentLink">
                <Header as="h1" content="Create Payment Link" />
                <Form onSubmit={this.onSubmit} error>
                    <Message error content={error} />
                    <Form.Dropdown
                        label="Product"
                        placeholder="Select Product"
                        name="product"
                        fluid
                        selection
                        value={this.state.product}
                        options={this.props.products.map((p) => ({ text: p.name, value: p.id }))}
                        onChange={this.onChange}
                    />
                    <Table>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={3}>Metadata</Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell>Name</Table.HeaderCell>
                                <Table.HeaderCell>Value</Table.HeaderCell>
                                <Table.HeaderCell />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {Object.keys(this.state.metadata).map((key) => (
                                <Table.Row>
                                    <Table.Cell>{key}</Table.Cell>
                                    <Table.Cell>{this.state.metadata[key]}</Table.Cell>
                                    <Table.Cell />
                                </Table.Row>
                            ))}
                            <Table.Row>
                                <Table.Cell>
                                    <Form.Input placeholder="Name" name="name" value={this.state.name} onChange={this.onChange} />
                                </Table.Cell>
                                <Table.Cell>
                                    <Form.Input placeholder="Value" name="value" value={this.state.value} onChange={this.onChange} />
                                </Table.Cell>
                                <Table.Cell>
                                    <Form.Button
                                        content="Add"
                                        type="button"
                                        onClick={() => {
                                            const { name, value } = this.state
                                            this.setState({
                                                metadata: { ...this.state.metadata, [name]: value },
                                                name: '',
                                                value: '',
                                            })
                                        }}
                                    />
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                    <Form.Button content="Submit" />
                </Form>
            </div>
        )
    }
}

CreatePaymentLink.proTypes = {}

const mapStateToProps = (state, ownProps) => {
    return {
        products: PaymentLinks.selector(state).products,
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(PaymentLinks.actionCreators, dispatch),
        ...bindActionCreators(routerActions, dispatch),
    },
})

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(CreatePaymentLink)
)
